/* LekkerSeal order tracking - URL handling.
 *
 * Moved out of an inline <script> in ls-track.liquid so it can be read and
 * diffed on its own. See snippets/ls-track-url.liquid for the full note on
 * why the path rewrite below exists.
 *
 * TWO WAYS A CUSTOMER ARRIVES
 *
 *   a) ?url=<full 2Ship shipment url>
 *      How existing courier links are wrapped.
 *
 *   b) ?TrackingNumber=..&Carrier=..&SId=..&ClientId=..
 *      The raw parameters, so notification links can point at
 *      lekkerseal.co.za directly and the customer never leaves the brand.
 *
 * THE PATH REWRITE - the important part
 *
 * Shopify fulfilments record tracking URLs as:
 *   https://africa.2ship.com/Tracking/Index?TrackingNumber=...&Carrier=...
 *
 * /Tracking/Index is a REDIRECT to /Tracking/TrackShipment. Top-level that is
 * invisible and works. Inside an iframe the redirect fails and leaves a blank
 * white frame - no console error, no failed request, nothing to notice.
 *
 * Verified on Lekker#3001 (SHIP14-00001346, RAM):
 *   Index in iframe         -> blank
 *   TrackShipment in iframe -> full status, carrier, expected date, history
 *
 * So Index is rewritten to TrackShipment before the src is set, and the
 * iframe never follows a redirect.
 *
 * SECURITY
 *
 * The original page took ?url= straight from the query string and set it as
 * the iframe src with no validation, so any link could render arbitrary
 * content inside a lekkerseal.co.za page under the real header and footer.
 * The allowlist check below runs BEFORE the rewrite, so a hostile URL is
 * rejected and never reaches the path logic.
 */
(function () {
  var ALLOWED = ['africa.2ship.com', 'www.2ship.com', '2ship.com'];
  var BASE = 'https://africa.2ship.com/Tracking/TrackShipment';

  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(fn, 1);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var frame = document.getElementById('2ShipTrackIframe');
    if (!frame) return;

    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }

    var raw = qs.get('url');

    /* Rebuild from raw 2Ship parameters when no ?url= was supplied. */
    if (!raw && qs.get('TrackingNumber')) {
      var keep = ['TrackingNumber', 'Carrier', 'SId', 'ClientId'];
      var parts = [];
      keep.forEach(function (k) {
        var v = qs.get(k);
        if (v) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
      raw = BASE + '?' + parts.join('&');
    }

    if (!raw) return;

    var u = null, ok = false;
    try {
      u = new URL(raw, window.location.origin);
      ok = (u.protocol === 'https:') && (ALLOWED.indexOf(u.hostname.toLowerCase()) !== -1);
    } catch (e) { ok = false; }

    if (!ok) {
      var w = document.getElementById('lstWarn');
      if (w) w.classList.add('on');
      if (window.console) console.warn('[lsTrack] rejected tracking url, host not allowed');
      return;
    }

    /* Index redirects to TrackShipment and the redirect dies in an iframe.
       Rewrite the path, keep every query parameter. */
    if (/^\/Tracking\/Index\/?$/i.test(u.pathname)) {
      u.pathname = '/Tracking/TrackShipment';
    }

    frame.setAttribute('src', u.href);

    var live = document.getElementById('lstLive');
    if (live) live.classList.add('on');
    var steps = document.getElementById('lstSteps');
    if (steps) steps.style.display = 'none';   // they already have a result
  });
})();
